<template>
  <div class="mt-8">
    <div class="pr-8 w-full flex justify-between font-bold border-b pb-1 text-sm">
      <p class="w-1/6">Date</p>
      <p class="flex-1">Type</p>
      <p class="w-1/6 text-right">TBA Entry</p>
      <p class="w-1/6 text-right">TBA Running Balance</p>
      <p class="w-1/6 text-right">TBC Used %</p>
      <p class="w-1/6 text-right">TBC Remaining</p>
    </div>
    <ul class="mt-2 space-y-2 text-sm">
      <li v-for="(transaction,idx) in sortedTransactions" :key="idx">
        <div class="flex justify-between">
          <div class="w-full flex justify-between">
            <p class="w-1/6 font-semibold">{{ transaction.date | moment('DD/MM/YYYY') }}</p>
            <p class="flex-1">{{ transaction.event }}</p>
            <p class="w-1/6 text-right">
              {{ (transaction.amount * (transaction.type === 'debit' ? -1 : 1)) | dollar }}
            </p>
            <p class="w-1/6 text-right" v-if="transaction.TBA_RUNNING_BALANCE">
              {{ transaction.TBA_RUNNING_BALANCE| dollar }}
            </p>
            <p class="w-1/6 text-right" v-else>-</p>
            <p class="w-1/6 text-right" v-if="transaction.USED_TBC_CAP">
              {{ transaction.USED_TBC_CAP| percent }}
            </p>
            <p class="w-1/6 text-right" v-else>-</p>
            <p class="w-1/6 text-right" v-if="transaction.REMAINING_TBC">
              {{ transaction.REMAINING_TBC| dollar }}
            </p>
            <p class="w-1/6 text-right" v-else>-</p>
          </div>
          <button
            class="ml-4 focus:outline-none cursor-pointer"
            @click="handleDeleteTransaction(transaction)"
          >
            <svg class="w-6 h-6 text-red-700" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path></svg>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'transfer-balance-cap-transactions',
  props: {
    transactions: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    sortedTransactions() {
      const reverseArr = this.transactions;
      return reverseArr.reverse();
    },
  },
  methods: {
    handleDeleteTransaction(idx) {
      this.$emit('delete-transaction', idx);
    },
  },
};
</script>

<style>

</style>
